module.exports = __webpack_public_path__ + "static/img/RWA454-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA454-G_1.png
// module id = EKCH
// module chunks = 0